module.exports = __webpack_public_path__ + "img/area-limit-cancel-btn.271fa42a.png";